import React from "react";

// SVG globe + gradient N mark (crisp, responsive, on-brand)
export function LogoMark({ size = 40, className = "" }) {
  const id = React.useId();
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none"
      className={className} aria-hidden="true" data-testid="logo-mark">
      <defs>
        <linearGradient id={`g-${id}`} x1="12" y1="52" x2="52" y2="12" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FF6B35" />
          <stop offset="0.55" stopColor="#FF6B35" />
          <stop offset="1" stopColor="#0055FF" />
        </linearGradient>
      </defs>
      <circle cx="32" cy="32" r="29" stroke="#2b3450" strokeWidth="1.4" />
      <ellipse cx="32" cy="32" rx="14" ry="29" stroke="#2b3450" strokeWidth="1.2" />
      <line x1="4" y1="24" x2="60" y2="24" stroke="#2b3450" strokeWidth="1.1" />
      <line x1="4" y1="40" x2="60" y2="40" stroke="#2b3450" strokeWidth="1.1" />
      <circle cx="9" cy="24" r="1.7" fill="#FF6B35" />
      <circle cx="55" cy="40" r="1.7" fill="#0055FF" />
      <path d="M20 46V18h5.6l12.8 17.4V18H44v28h-5.6L25.6 28.6V46H20Z"
        fill={`url(#g-${id})`} />
    </svg>
  );
}

export default function Logo({ variant = "header", withTagline = true, onClick }) {
  const markSize = variant === "footer" ? 44 : 40;
  const textSize = variant === "footer" ? "text-2xl" : "text-xl md:text-2xl";
  return (
    <div className="flex items-center gap-2.5 select-none" onClick={onClick} data-testid="brand-logo">
      <LogoMark size={markSize} />
      <div className="flex flex-col leading-none">
        <span className={`font-sans font-black tracking-tight text-white ${textSize}`} style={{ letterSpacing: "0.02em" }}>
          NEX<span className="nx-gradient-text">O</span>DUM
        </span>
        {withTagline && (
          <span className="hidden sm:block text-[8px] md:text-[9px] tracking-[0.32em] text-slate-400 uppercase mt-1">
            Historias que nos conectan
          </span>
        )}
      </div>
    </div>
  );
}
